var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnloggedContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "0 -960 960 960",
    width: 20,
    fillOpacity: "20%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500-820v-60h380v60H500Zm0 140v-60h380v60H500Zm0 140v-60h380v60H500ZM755-80q-116 0-236.5-56T295-295Q192-398 136-518.5T80-755q0-19.286 12.857-32.143T125-800h140q14 0 24 10t14 25l26.929 125.641Q332-625 329.5-613.5q-2.5 11.5-10.729 19.726L219-493q26 44 55 82t64 72q37 38 78 69.5t86 55.5l95-98q10-11 23.151-15T646-329l119 26q15 4 25 16.044T800-260v135q0 19.286-12.857 32.143T755-80ZM189-548l81-82-23-110H140q2 42 13.5 88.5T189-548Zm369 363q41 19 89 31t93 14v-107l-103-21-79 83ZM189-548Zm369 363Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnloggedContact);
export default __webpack_public_path__ + "static/media/unlogged-contact.23631f9d9242e8271513451b0ae3dcdb.svg";
export { ForwardRef as ReactComponent };